import React from "react";
import Service from "../../../Pages/Service";
const ServicesPage = () => {
  return <Service></Service>;
};

export default ServicesPage;
